'use client';

import { ComponentProps } from 'react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/ui/Button';
import { cx } from '@/ui/cva';

import { Spinner } from '../Spinner';

type FormSubmitButtonProps = ComponentProps<typeof Button>;

export function FormSubmitButton({
    children,
    className,
    ...props
}: FormSubmitButtonProps) {
    const {
        formState: { isSubmitting },
    } = useFormContext();

    return (
        <Button
            color="darkgray"
            variant="outlined"
            className={cx('flex-auto', className)}
            {...props}
            type="submit"
            disabled={isSubmitting}
        >
            {isSubmitting && (
                <span className="flex size-4 flex-none">
                    <Spinner />
                </span>
            )}
            <span className={cx('flex-auto', isSubmitting && '-ml-5')}>
                Submit
            </span>
        </Button>
    );
}
